<template>
  <div class="cupon_page">
    <div class="top_banner">
      <img class="top_logo" src="../../assets/tfsharelogo.png" alt="">
      <div class="middel-info">
        <div>铁粉生活</div>
        <div class="s_text">湖南广电旗下唯一本地生活服务APP</div>
      </div>
      <div id="btn_open">打开APP</div>
    </div>
    <div style="margin-top: 55px;" v-if="!isEmpty">
      <div class="top">
        <div class="info">
          <span class="name">￥</span><span class="money">{{ couponInfo.price | priceFormat }}</span>元抵扣券无门槛
          <div class="name">{{ couponInfo.name }}</div>
        </div>
      </div>
      <div class="content">
        <div class="title">使用说明</div>
        <div class="time">活动时间：{{ couponInfo.SDate }}至{{ couponInfo.EDate }}</div>
        <div class="desc" v-if="couponInfo.describ">
          优惠内容：{{ couponInfo.describ }}
        </div>
      </div>
    </div>
    <div v-else class="empty_container" :style="{'height': contentHeight + 'px'}">优惠券已被删除</div>
    <Spin fix size="large" v-if="loading"></Spin>
  </div>
</template>

<script>

export default {
  name: "coupon",
  data() {
    return {
      loading: true,
      isEmpty: false,
      couponId: '',
      couponInfo: {},
      contentHeight: document.documentElement.clientHeight,
    }
  },
  filters: {
    priceFormat: function (value) {
      if (!value) return '0'
      if (value % 100 > 0) {
        return (value / 100).toFixed(2)
      } else {
        return (value / 100).toFixed(0)
      }
    }
  },
  mounted() {
    let param = this.$route.query
    this.couponId = param.id

    // linkType(13:优惠券)
    var data = XInstall.parseUrlParams();
    new XInstall({
      appKey : "mq81ipn",
      buttonId: [
        { idName: 'btn_open', params: {linkType: 13, linkId: param.id} }
      ]
    }, data);

    this.getCouponInfo()
  },
  methods: {
    getCouponInfo() {
      let that = this
      that.loading = true
      let searchParam = {
        couponId: this.couponId
      }
      this.$http.get('/couponPhone/open/getAppCouponInfo', searchParam, function (res) {
        that.couponInfo = res.data
        that.isEmpty = false
        that.loading = false
      }, function () {
        that.couponInfo = {}
        that.isEmpty = true
        that.loading = false
      })
    }
  }
}
</script>

<style scoped>
.cupon_page {
  position: relative;
}
.top_banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  background: rgb(255, 255, 255);
  padding: 6px;
  color: #000;
  border-bottom: 1px solid #eee;
}
.top_logo {
  width: 40px;
  border-radius: 6px;
}
.middel-info {
  flex: 1;
  margin-left: 6px;
  font-size: 16px;
}
.s_text {
  font-size: 12px;
  color: rgba(153,153,153,1);
}
#btn_open {
  background-color: #3C74F2;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 20px;
  color: #fff;
}
.top {
  position: relative;
  height: 280px;
  background: url("../../assets/wallet.png") no-repeat center center;
  background-size: cover;
}
.info {
  position: absolute;
  top: 100px;
  left: 15%;
  right: 15%;
  text-align: center;
}
.money {
  color: #F33026;
  font-size: 28px;
}
.name {
  color: #F33026;
}
.content {
  padding: 15px;
}
.title {
  color: #333;
  font-size: 18px;
}
.time {
  padding: 15px 0;
}
.empty_container {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/coupon.vue